'use strict';
var parent = require('../../es/array/to-spliced');

module.exports = parent;
